import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Icon } from "@material-ui/core";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "max-content",
    height: "auto",
    display: "flex",
    justifyContent: "space-evenly",
  },
  navBtn: {
    color: theme.palette.grey[600],
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    "& span:last-child": {
      display: "none",
    },
  },
  navBtnActive: {
    color: theme.palette.primary.main,
    "& span:last-child": {
      display: "inline-block",
    },
  },
  navIcon: {
    fontSize: "2.5em",
  },
}));

const navButtons = [
  {
    label: "Mapa",
    routeName: "",
    icon: (c) => <Icon className={c}>map</Icon>,
  },
  {
    label: "Hoy",
    routeName: "hoy",
    icon: (c) => <Icon className={c}>today</Icon>,
  },
  {
    label: "Gráficas",
    routeName: "graficas",
    icon: (c) => <Icon className={c}>assessment</Icon>,
  },
  {
    label: "Vacunas",
    routeName: "vacunas",
    icon: (c) => <Icon className={c}>vaccines</Icon>,
  },
  {
    label: "Info",
    routeName: "info",
    icon: (c) => <Icon className={c}>info</Icon>,
  },
];

const NavBar = React.memo(() => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {navButtons.map((navBtn, idx) => (
        <NavLink
          key={idx}
          className={classes.navBtn}
          label={navBtn.label}
          to={`/${navBtn.routeName}`}
          exact
          activeClassName={classes.navBtnActive}
        >
          {navBtn.icon(classes.navIcon)}
          <span>{navBtn.label}</span>
        </NavLink>
      ))}
    </div>
  );
});

export default NavBar;
